import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../user/Actions";
import { getTokenCookie, getCredentials, clearTokenCookie } from "../helpers/auth-header";
import { getLocale, history } from "../helpers";

export function AuthenticateRoute({ Component, ...rest }) {
  const dispatch = useDispatch();
  const { loggedIn, user, loginError } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(true);
  const autologinAttempted = useRef(false);

  useEffect(() => {
    const userToken = getTokenCookie();
    if (userToken && (!user || (user.token && user.token !== userToken))) {
      dispatch(userActions.userData());
    } else {
      setLoading(false);
    }
  }, []); 

  useEffect(() => {
    if (!loading) return;
    if (loginError && !loggedIn && !autologinAttempted.current) {
      autologinAttempted.current = true;
      const credentials = getCredentials();
      if (credentials) {
        dispatch(userActions.autologin(credentials.email, credentials.password));
      } else {
        clearTokenCookie();
        setLoading(false);
        history.push(getLocale(history.location.pathname, true) + "/stores/login");
      }
    } else if (loggedIn !== undefined || user !== undefined) {
      setLoading(false);
    }
  }, [loggedIn, user, loginError]); 

  const userObj =
    user && user.user instanceof Array && user.user[0]
      ? user.user[0]
      : user && !(user.user instanceof Array)
      ? user.user
      : {};

  return (
    <>
      {!loading && loggedIn && <Component user={userObj} {...rest} />}{" "}
    </>
  );
}

export default AuthenticateRoute;
